import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { NProcessFlow } from '../PF/PF.types'

export function IDB_processFlowRead(id: number) {
    return IDB_rowRead<NProcessFlow.IProcessFlowV2>(IDB_globalDb, 'process_flows', id)
}

export function IDB_processFlowsDelete(ids: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'process_flows', ids)
}

export function IDB_processFlowsReadAll() {
    return IDB_rowsReadAll<NProcessFlow.IProcessFlowV2>(IDB_globalDb, 'process_flows')
}

export function IDB_processFlowsWrite(processFlows: NProcessFlow.IProcessFlowV2[]) {
    return IDB_rowsWrite(IDB_globalDb, 'process_flows', processFlows)
}
